import { Backdrop, CircularProgress, Container, Divider, Grid,IconButton } from '@material-ui/core';
import { ArrowBack, Save as SaveIcon, Delete as DeleteIcon } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ButtonUI from '../../components/ui/ButtonUI';
import LoadingUI from '../../components/ui/LoadingUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { MvmShedAdd, MvmShedSchedule } from '../../interfaces/Mvm';
import MvmApi from '../../services/MvmApi';
import MvmSummary from './components/MvmSummary';
import { useStyles } from './Style';
import SelectShedMovementType from '../../components/Form/SelectShedMovementType';
import MUIDataTable from 'mui-datatables';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import getDefaultGridOptions from "../../utils/componentUtils";
import * as Yup from "yup";
import AlertDialog from '../../components/ui/AlertDialog';
import { useAuth } from '../../hooks/auth';

interface Params {
    mvmNumber: string;
}

interface IFormInput {
    mvmNumber: any;
    mvmNumberUnique: string;
    shed: any;
    shedMovementType: any;
}

const AddMvmShed: React.FC = () => {
    const history = useHistory()
    const classes = useStyles()
    const { t } = useTranslation("Mvm")
    const { t: tShed } = useTranslation("Shed");
    const { t: _t } = useTranslation("General")
    const { t: tValidation } = useTranslation("Validation");    
    const { t: tWindow } = useTranslation("Window");    
    const { enqueueSnackbar } = useSnackbar()
    const [mvm, setMvm] = useState<any>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [queryMvmId, setQueryMvmId] = useState<any>(null)
    const { control, handleSubmit, setValue, getValues, clearErrors, setError } = useForm<IFormInput>(
    {
        defaultValues: { 
            mvmNumber: {}, 
            mvmNumberUnique: '', 
            shed: {},
            shedMovementType: {} 
        }
    })
    const [mvmSheds, setMvmSheds] = useState<MvmShedSchedule[]>([]);
    const [loadingShedList, setLoadingShedList] = useState<boolean>(false);
    const [columnsShedList, setColumnsShedList] = useState<any>([])
    const [itemIndexDelete, setItemIndexDelete] = useState<number>(0)    
    const [circularLoading, setCircularLoading] = useState(false);

    useEffect(() => {
        if (itemIndexDelete > 0) {
            var itemsTemp = mvmSheds.filter((element) => element.order !== itemIndexDelete)

            var order = 1
    
            itemsTemp.forEach((element) => {
                element.order = order;
                order++;
            })
    
            setMvmSheds(itemsTemp)
    
            enqueueSnackbar(_t("returnSubmitDeleteFormSuccess"), {
                variant: "success",
            })

            setItemIndexDelete(0)
        }

        var columns = [
            {
                name: "order",
                options: {
                    display: false,
                },
            },
            {
                name: "shedId",
                options: {
                    display: false,
                },
            },
            {
                name: "movementTypeId",
                options: {
                    display: false,
                },
            },
            {
                name: "shedType",
                options: {
                    display: false,
                },
            },
            {
                name: "shedCode",
                label: String(tShed("shed")),
                options: {
                    customBodyRender: (
                        value: any,
                        tableMeta: any,
                        updateValue: any
                    ) => {
                        var splited = value.split(" - ");
                        if (splited[1] === undefined) splited[1] = tableMeta.rowData[3]; //se ja nao vier o tipo no valor, pegar da coluna da tabela
                        return (
                            splited[0] +
                            " - " +
                            (splited[1] === "D"
                                ? tWindow("unload")
                                : tWindow("load"))
                        );
                    },
                },
            },
            {
                name: "movementTypeDescription",
                label: String(tShed("movementType")),
                options: {
                    display: true,
                    sort: false,
                    setCellHeaderProps: () => ({
                        align: "center",
                    }),
                    setCellProps: () => ({
                        align: "center",
                    }),
                },
            },
            {
                name: "",
                options: {
                    sort: false,
                    setCellProps: () => ({
                        align: "center",
                    })
                },
            },
            {
                name: "",
                options: {
                    sort: false,
                    setCellProps: () => ({
                        align: "right",
                    }),
                    customBodyRender: (
                        value: any,
                        tableMeta: any,
                        updateValue: any
                    ) => renderButtons(tableMeta),
                },
            }
        ]

        setColumnsShedList(columns)
        setLoadingShedList(false)
    }, [loadingShedList])

    const renderButtons = (tableMeta: any) => {
        return (
            tableMeta.rowData[3] == 'C' &&
            <AlertDialog
                dialogTitle={_t("dialogDeleteTitle")}
                dialogContentText={_t("dialogDeleteContentText")}
                cancelTextButton={_t("cancelDeleteTextButton")}
                confirmTextButton={_t("confirmDeleteTextButton")}
                confirmDialogFunction={() => {
                    setItemIndexDelete(tableMeta.rowData[0])
                    setLoadingShedList(true)
                }}
                Button={
                    <IconButton size="small" edge="end">
                        <DeleteIcon />
                    </IconButton>
                }
            />
        );
    };   

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: mvmSheds.length > 0 ? "pointer" : "",
                },
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 8,
                    paddingRight: 4,
                    paddingBottom: 6,
                    paddingTop: 6,
                },
                head: {
                    padding: 8,
                }
            },
        },
    });

    useEffect(() => {
        var mvmId = Number(window.location.pathname.replace('/AddMvmShed/', ''));
        if (!isNaN(mvmId))
            setQueryMvmId(mvmId)

    }, [window.location.pathname]);

    useEffect(() => {
        if (!mvm)
            return
            //Sheds para apresentar na tela: os sheds do mvm:
            var count = 1;
            var arryMvmSheds = mvm.sheds.map(
                (element: {
                    shedId: any;
                    shedCode: any;
                    shedType: any;
                    movementTypeId: any;
                    movementTypeDescription: any;
                    tolerance: any;
                }) => {
                    var newItem: MvmShedSchedule = {
                        order: count,
                        shedId: element.shedId,
                        shedCode: element.shedCode
                            .split("-")[0]
                            ?.trim(),
                        shedType: element.shedType,
                        movementTypeId: element.movementTypeId,
                        movementTypeDescription:
                            element.movementTypeDescription,
                        tolerance: element.tolerance
                    };

                    count++;
                    return newItem;
                }
            )
            setMvmSheds(arryMvmSheds);
    }, [mvm])

    const onSummaryChange = (data: any) => {
        
        if (!data) {
            setMvm(null)
            return
        }

        setMvm(data)
    }

    const onSubmit = (data: any) => {
        if (!mvm) {
            enqueueSnackbar(t("returnSearchMvmNotFoundMessage"), { variant: 'warning' })
            return
        }

        if (mvm.composition && mvm.mvmType !== 'C') {
            enqueueSnackbar(t("mvmCabinCannotContainInvoices"), { variant: 'warning' })
            return
        }

        setIsLoading(true)

        let hasErrors: boolean = false;

    }
    const formValidation = async (data: any) => {
        var result = false;
        clearErrors("shed");
        clearErrors("shedMovementType");
        try {
            const schema = Yup.object().shape({
                shed: Yup.object()
                    .nullable()
                    .required(tValidation("requiredField"))
                    .shape({
                        code: Yup.string().required(
                            tValidation("requiredField")
                        ),
                    }),
                shedMovementType: Yup.object()
                    .nullable()
                    .required(tValidation("requiredField"))
                    .shape({
                        code: Yup.string().required(
                            tValidation("requiredField")
                        ),
                    }),
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            result = true;
        } catch (err) {
            var errors: string[] = [];

            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error) => {
                    if (
                        errors.filter((element) =>
                            element.includes(error.message)
                        ).length === 0
                    )
                        errors.push(error.message);

                    setError(
                        error.path?.split(".")[0] as
                            | "shed"
                            | "shedMovementType",
                        { message: error.message }
                    );
                });

                errors.forEach((element) => {
                    if (element === tValidation("requiredField"))
                        enqueueSnackbar(_t("requiredFieldsValidation"), {
                            variant: "warning",
                        });
                    else enqueueSnackbar(element, { variant: "warning" });
                });
            }

            result = false;
        }

        return result;
    }; 

    const addItemOnList = async () => {
        var data = getValues();

        if (!(await formValidation(data))) return;

        var newValue: MvmShedSchedule = {
            order: mvmSheds.length + 1,
            shedId: Number(data.shed.code),
            shedCode: data.shed.label.split("-")[0]?.trim(),
            shedType: data.shed.shedType,
            movementTypeId: data.shedMovementType.code,
            movementTypeDescription: data.shedMovementType.label,
            tolerance: data.shedMovementType.tolerance
        };
        setValue("shed", {});
        setValue("shedMovementType", {});

        if (!validateNewShed(newValue))
            return

        setLoadingShedList(true)
        setMvmSheds([...mvmSheds, newValue]);
    };

    const onDragEnd = (result: any) => {
        // como eu faço para atualizar a ordem no mvmSheds com a nova ordem?
        const { destination, source, draggableId } = result;
        if (!destination) {
            return;
        }

        if (destination.index === source.index) {
            return;
        }
        
        const newSheds = Array.from(mvmSheds);
        newSheds.splice(source.index, 1);
        newSheds.splice(destination.index, 0, mvmSheds[source.index]);

        for (var i = 0; i < newSheds.length; i++) {
            newSheds[i].order = i+1
        }

        setLoadingShedList(true)
        setMvmSheds(newSheds);
    };

    const validateNewShed = (newValue: MvmShedSchedule): boolean => {
        var shedAlreadyInserted = mvmSheds.filter(
            (element) =>
                element.order !== newValue.order &&
                element.shedCode === newValue.shedCode &&
                element.movementTypeId === newValue.movementTypeId
        ).length > 0

        if (shedAlreadyInserted) {
            enqueueSnackbar(tShed("shedAlreadyInserted"), {
                variant: "warning",});
            return false
        }

        return true
    }
    const saveChanges = (addShed: boolean) => {
        setCircularLoading(true);

        let model: MvmShedAdd = {
            id: mvm.id,
            addShed,
            sheds: addShed ? mvmSheds : [],
        };
        
        MvmApi.addMvmShed(model)
            .then(() => {
                enqueueSnackbar(_t("returnSubmitEditFormSuccess"), {
                    variant: "success",
                });
                history.push("/ShedManage/3");
            })
            .finally(() => {
                setCircularLoading(false);
            });
        
    };
    return (
        <Container maxWidth={false} component="main">
            <Backdrop style={{ zIndex: 99999 }} open={circularLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
                
            <PageTitle title={t("titleAddMvmShedLoad")} />

            {
                isLoading ? <LoadingUI /> :
                (
                <div className={classes.rootContent}>
                    <form onSubmit={handleSubmit(onSubmit)} >                    
                        <Divider style={{ marginTop: '10px' }} />
                        <MvmSummary
                            control={control}
                            name={"summary"}
                            onChange={onSummaryChange}
                            setValue={setValue}
                            queryMvmId={queryMvmId}
                            includeProperties={["Sheds"]}
                        />
                    </form>
                        
                    {!mvm ? <></> : 
                    <Grid container spacing={1}>
                            <Grid container spacing={1}>
                                <SelectShedMovementType
                                    nameSelectShed={"shed"}
                                    nameSelectMovementType={"shedMovementType"}
                                    control={control}
                                    setValue={setValue}
                                    title={""}
                                    showConfirmButton={true}
                                    onButtonClick={addItemOnList}
                                    shedType="C"
                                />
                            </Grid>  


                            <Grid
                                style={{
                                    marginTop: 5,
                                    width: "98%",
                                    marginLeft: 10,
                                    marginBottom: 10,
                                }}>
                            {!loadingShedList && <MuiThemeProvider theme={myTheme}>
                                <DragDropContext onDragEnd={onDragEnd}>
                                    <Droppable droppableId="droppable">
                                        {(provided: any) => (
                                        <div {...provided.droppableProps} ref={provided.innerRef}>
                                        <MUIDataTable
                                            title=""
                                            data={mvmSheds}
                                            columns={columnsShedList}

                                            options={{
                                                ...getDefaultGridOptions(_t),
                                                serverSide: false,
                                                pagination: false,
                                                sort: false,
                                                // sortOrder: {
                                                //     name: "order",
                                                //     direction: "asc",
                                                // },
                                                selectToolbarPlacement: "none",
                                                filter: false,
                                                search: false,
                                                download: false,
                                                print: false,
                                                viewColumns: false,
                                                selectableRows: "none",
                                                
                                            }}
                                        />
                                        {provided.placeholder}
                                        </div>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                            </MuiThemeProvider>}
                            </Grid>
                                                                          
                        <Grid container spacing={1}>
                                <Grid item xs={12}>

                                </Grid>
                                <ButtonUI
                                    style={{ marginTop: 15 }}
                                    variant="outlined"
                                    color="secondary"
                                    onClick={() => saveChanges(false)}
                                    >
                                    {'Continuar sem adicionar galpão'}
                                </ButtonUI>
                                <ButtonUI
                                    style={{ marginTop: 15, marginLeft: 15 }}
                                    variant="outlined"
                                    color="primary"
                                    onClick={() => saveChanges(true)}
                                    startIcon={<SaveIcon />}>
                                    {_t("save")}
                                </ButtonUI>
                        </Grid> 
                        </Grid>               
                    }
                </div>
                )
            }
        </Container>
    )
}
export default AddMvmShed;
